<template>
  <el-dialog
      v-el-drag-dialog
      :title="systemUser.systemUserID? '编辑用户' : '新增用户'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="user-edit"
      width="1000px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="systemUser"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="基本信息" name="first">
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户类型" prop="userType">
                <el-radio-group v-model="systemUser.userType">
                  <el-radio :label="1">内部用户</el-radio>
                  <el-radio :label="2">外部用户</el-radio>
                  <el-radio :label="3">高级用户</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账套类型">
                <el-select v-model="systemUser.accountSetName" clearable placeholder="请选择">
                  <el-option
                      v-for="item in accountSetNameList"
                      :key="item.pkid"
                      :label="item.accountSetName"
                      :value="item.accountSetName"
                      @click.native="selectAccountSetName(item)"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" prop="tempID">
                <div style="display: flex;flex-direction: row;">
                  <el-input v-model="systemUser.employeeName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectEmployee.open()"/>
                  </el-input>
                  <employee-select ref="selectEmployee" @select="onSelectEmployee"/>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号">
                <el-input v-model="systemUser.mobile" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="企业微信账号">
                <el-input v-model="systemUser.weChatAccount" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户名" prop="userName">
                <el-input v-model="systemUser.userName" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="密码" prop="password">
                <el-input v-model="systemUser.password" :readonly="systemUser.systemUserID>0" type="password" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="确认密码" prop="confirmPd">
                <el-input v-model="systemUser.confirmPd" :readonly="systemUser.systemUserID>0" type="password" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="邮箱">
            <el-input v-model="systemUser.email" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="备注" prop="note">
            <el-input
                v-model="systemUser.note"
                type="textarea"
                placeholder="请输入"/>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="角色分配" name="second">
          <el-transfer
              v-model="systemUser.roleIds"
              filterable
              :data="roleList"
              :props="{key: 'id', label: 'roleName'}"
              :titles="['未分配角色', '已分配角色']"/>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  export default {
    name: "UserEdit",
    components: {EmployeeSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        activeName: "first",
        accountSetNameList:[],
        systemUser: {
          systemUserID: 0,
          userName: "",
          employeeName: "",
          weChatAccount: "",
          password: "",
          confirmPd: "",
          employeeID: 0,
          customerID: 0,
          tempID: 0,
          note: "",
          userType: 0,
          mobile: "",
          status: "",
          roleName: "",
          userTypeName: "",
          departmentName: "",
          departmentId: 0,
          employeeNo: "",
          gender: "",
          authorityString: "",
          accountSetName: "新时达电气",
          accountSetId: "",
          roleIds: [],
        },
        roleList: [],
        ruleValidate: {
          userName: {required: true, message: "不能为空",trigger: "blur"},
          password: {required: true, message: "不能为空",trigger: "blur"},
          confirmPd: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.getAccountSetNameList();
        if(id>0) {
          this.systemUser.systemUserID = id;
          this.getData();
        }
        this.getAllRole();
      },
      getData() {
        this.$http
          .get("basic", `system/user/${this.systemUser.systemUserID}`)
          .then(resp => {
            this.systemUser = Object.assign(this.systemUser, resp);
            this.systemUser.confirmPd = this.systemUser.password;
            if(this.systemUser.customerID > 0) {
              this.systemUser.tempID = this.systemUser.customerID;
            }else{
              this.systemUser.tempID = this.systemUser.employeeID;
            }
          });
      },
      getAccountSetNameList() {
        this.$http
          .get("basic", "accountSets/list")
          .then(resp => {
            console.log(resp);
            this.accountSetNameList = resp;
          });
      },
      selectAccountSetName(item) {
        console.log(item);
        this.systemUser.accountSetId = item.pkid;
        this.systemUser.accountSetName = item.accountSetName;
      },
      getAllRole() {
        if (this.roleList.length === 0) {
          this.$http
            .get("basic", "roles/list")
            .then(resp => {
              this.roleList = resp;
            });
        }
      },
      handleSubmit() {
        if(this.systemUser.password !== this.systemUser.confirmPd) {
          this.$message.error("请统一新密码");
          return;
        }
        if(this.systemUser.userType == 2) {
          this.systemUser.customerID = this.systemUser.tempID;
          this.systemUser.employeeID = -1;
        }else{
          this.systemUser.customerID = -1;
          this.systemUser.employeeID = this.systemUser.tempID;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if(this.systemUser.systemUserID>0) {
              this.$http
                .put("basic", "system/user", this.systemUser)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }else {
              this.$http
                .post("basic", "system/user", this.systemUser)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
      onSelectEmployee(row) {
        this.systemUser.tempID = row.employeeID;
        this.systemUser.employeeName = row.employeeName;
        this.systemUser.mobile = row.mobile;
      },
    },
  };

</script>
<style lang="scss">
  .el-transfer-panel{
    width: 360px!important;
  }
</style>
